/**
 * Created by mac on 9/16/23
 */

const Tutorial = function () { 
    cleverapps.EventEmitter.call(this);
    this.active = undefined;
    this.scenarios = [];
    this.onFinishCallback = function () { };
};

Tutorial.prototype = Object.create(cleverapps.EventEmitter.prototype);
Tutorial.prototype.constructor = Tutorial;

Tutorial.prototype.register = function (scenarioCreator) {
    this.scenarios.push(scenarioCreator);
    this.scenarios.sort((a, b) => b.priority - a.priority);
};

Tutorial.prototype.isActive = function () {
    return this.active !== undefined;
};

Tutorial.prototype.getActive = function () {
    return this.active;
};

Tutorial.prototype.hasFocus = function () {
    return this.active !== undefined && cleverapps.focusManager.focus === this.active.name;
};

Tutorial.prototype.getCurrentStep = function () {
    return this.active && this.active.getCurrentStep();
};

Tutorial.prototype.checkConditions = function (options) {
    options = options || {};

    const active = this.getActive();
    if (!active) {
        return false;
    }

    if (options.tutorial && options.tutorial !== active.name) {
        return false;
    }

    const step = active.getCurrentStep();
    if (!step || step.isFinished()) {
        return false;
    }

    return step.checkConditions(options);
};

Tutorial.prototype.getInfo = function () {
    const info = this.active ? {
        name: this.active.name,
        stepNo: this.active.stepNo
    } : undefined;
    return info;
};

Tutorial.prototype.run = function (Scenario, f) {
    this.active = Scenario;

    this.onFinishCallback = f || function () {};

    runCleaners(this);
    cleverapps.gameManager.on("pause", this.onPause.bind(this), this);
    cleverapps.gameManager.on("resume", this.onResume.bind(this), this);
    cleverapps.inputDispatcher.on("pointerdown", this.onTouchBegan.bind(this), this);

    Scenario.start();

    this.trigger("nextTutorialStep");
};

Tutorial.prototype.stop = function (reason) {
    if (!this.active) {
        return;
    }

    const active = this.active;
    this.active = undefined;

    runCleaners(this);
    this.hiddenAt = undefined;

    const step = active.getCurrentStep();
    if (step && !step.isFinished()) {
        active.logStepEvent(TutorialScenario.EVENTS.STEP_QUIT, {
            reason: reason || "other",
            window: cleverapps.focusManager.currentWindow() ? cleverapps.focusManager.focus : ""
        });
        step.finish();
    }

    active.onFinishScenario();

    this.trigger("finishTutorial");
    this.onFinishCallback();
};

Tutorial.prototype.skip = function () {
    if (!this.active) {
        return;
    }

    cleverapps.forces.onceForceClosed = undefined;

    if (cleverapps.forces.isRunningForce()) {
        cleverapps.forces.closeRunningForce();
    }

    this.stop("skip");

    const window = cleverapps.focusManager.currentWindow();
    cleverapps.focusManager.setEventNodes(window ? [window] : []);
};

Tutorial.prototype.startNextStep = function () {
    if (!this.active) {
        return;
    }

    const step = this.active.getCurrentStep();

    if (!step) {
        this.stop();
        return;
    }

    if (!step.isFinished()) {
        return;
    }

    if (cleverapps.restoreProgress.isOpened()) {
        cleverapps.restoreProgress.onceRestoreFinished = this.startNextStep.bind(this);
        return;
    }
  
    if (step.force && cleverapps.forces.getRunningForce() === step.force) {
        cleverapps.forces.closeRunningForce();
    }
   
    this.active.startNextStep();

    if (!this.active) {
        return;
    }

    if (this.active.getCurrentStep()) {
        this.trigger("nextTutorialStep");
    } else {
        this.stop();
    }
};

Tutorial.prototype.onPause = function () {
    const step = this.getCurrentStep();
    if (!step || step.isFinished() || this.hiddenAt) {
        return;
    }

    this.hiddenAt = Date.now();
    this.active.logStepEvent(TutorialScenario.EVENTS.STEP_HIDE);
};

Tutorial.prototype.onResume = function () {
    if (!this.hiddenAt || !this.active) {
        return;
    }

    const hidden = Math.round((Date.now() - this.hiddenAt) / 1000);
    this.hiddenAt = undefined;
    this.active.logStepEvent(TutorialScenario.EVENTS.STEP_RESUME, { hidden });
};

Tutorial.prototype.onTouchBegan = function (touch) {
    const step = this.getCurrentStep();
    if (!step || step.isFinished()) {
        return;
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    if (!scene) {
        return;
    }

    const point = scene.convertToNodeSpace(touch.getLocation());
    const rects = step.listTargetRects ? step.listTargetRects() : [];

    const onTarget = rects.some((rect) => cc.rectContainsPoint(rect, point));
    this.active.noteTouch(onTarget ? "target" : "off");
};

Tutorial.prototype.reportWrong = function () {
    if (this.active) {
        this.active.noteTouch("wrong");
    }
};

Tutorial.prototype.isInputLocked = function () {
    const step = this.getCurrentStep();
    return Boolean(step && !step.isFinished() && step.strictInput);
};

Tutorial.prototype.hasSavedTutorial = function () {
    return cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.tutorial;
};

Tutorial.prototype.restoreSavedTutorial = function () {
    if (!this.hasSavedTutorial()) {
        return;
    }

    const savedData = cleverapps.loadedSnapshot.tutorial;
    delete cleverapps.loadedSnapshot.tutorial;

    const savedScenario = this.scenarios.find((scenario) => scenario.name === savedData.name);
    if (!savedScenario) {
        console.log(savedData, this.scenarios);
        throw `no such tutorial ${savedData.name}`;
    }

    if (savedScenario.options.restore === false) {
        return;
    }

    savedScenario.setStep(savedData.stepNo);

    return savedScenario;
};

Tutorial.prototype.getAvailableScenario = function () {
    return this.scenarios.find((scenario) => !scenario.manual && scenario.isAvailable());
};

Tutorial.prototype.findScenario = function (name) {
    return this.scenarios.find((scenario) => scenario.name === name);
};

Tutorial.prototype.startScenario = function (scenario) {
    scenario = scenario || this.getAvailableScenario();

    const saveScenario = this.restoreSavedTutorial();
    if (saveScenario) {
        scenario = saveScenario;
    } else if (scenario) {
        scenario.setStep(0);
    }

    if (scenario) {
        cleverapps.focusManager.display({
            focus: scenario.name,
            control: [],
            keepControls: scenario.options.keepControls,
            stack: true,
            actions: [
                function (f) {
                    this.run(scenario, f);
                }.bind(this)
            ]
        });
    }
};

Tutorial.prototype.onAfterResize = function () {
    this.trigger("onResize");
};
